import React from "react";
import WaveText from "../WaveText";

export default function JumbledSentenceGeneratorPanel({
  showJumbledSentenceGenerator, generatedJumbledSentence, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showFourOpinionsGenerator, showCommunicativeSituationsGenerator,
  showMatchingHalvesGenerator, showErrorCorrectionGenerator, showGrammarRulesGenerator,
  jumbledSentenceMode, setJumbledSentenceMode,
  jumbledSentenceInput, setJumbledSentenceInput, jumbledSentenceLevel, setJumbledSentenceLevel,
  jumbledSentenceCount, setJumbledSentenceCount, jumbledSentenceLoading,
  setGeneratedJumbledSentence,
  handleJumbledSentenceGenerate, handleJumbledSentenceInsert, handleJumbledSentenceCancel,
}) {
  if (!((showJumbledSentenceGenerator || generatedJumbledSentence) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleJumbledSentenceCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Word Order Exercise</span>
      </div>

      <div style={{ display: 'flex', gap: 4, background: '#f0eeff', borderRadius: 8, padding: 3 }}>
        {['generate', 'custom'].map(m => (
          <button
            key={m}
            onClick={() => { setJumbledSentenceMode(m); setJumbledSentenceInput(''); setGeneratedJumbledSentence(null); }}
            style={{
              flex: 1, fontSize: 13, fontWeight: 600, padding: '6px 0', borderRadius: 6, border: 'none', cursor: 'pointer', transition: 'all 0.18s',
              background: jumbledSentenceMode === m ? '#8a2be2' : 'transparent',
              color: jumbledSentenceMode === m ? '#fff' : '#8a2be2',
            }}
          >
            {m === 'generate' ? '✨ Generate' : '📝 My sentences'}
          </button>
        ))}
      </div>

      <textarea
        value={jumbledSentenceInput}
        onChange={e => setJumbledSentenceInput(e.target.value)}
        placeholder={jumbledSentenceMode === 'custom'
          ? 'Paste your sentences here, one per line:\nShe goes to school every day.\nThey were playing football in the park.'
          : 'Describe the topic or vocabulary to base the sentences on...'}
        rows={jumbledSentenceMode === 'custom' ? 6 : 4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          CEFR Level:
          <select
            value={jumbledSentenceLevel}
            onChange={e => setJumbledSentenceLevel(e.target.value)}
            style={{ fontSize: 14, padding: '6px 8px', borderRadius: 6, border: '1.5px solid #cfcfff', background: '#fff', cursor: 'pointer' }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>
        {jumbledSentenceMode === 'generate' && (
          <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
            Sentences:
            <select
              value={jumbledSentenceCount}
              onChange={e => setJumbledSentenceCount(parseInt(e.target.value))}
              style={{ fontSize: 14, padding: '6px 8px', borderRadius: 6, border: '1.5px solid #cfcfff', background: '#fff', cursor: 'pointer' }}
            >
              <option value={3}>3</option>
              <option value={5}>5</option>
              <option value={7}>7</option>
              <option value={10}>10</option>
            </select>
          </label>
        )}
      </div>

      <button
        onClick={handleJumbledSentenceGenerate}
        disabled={jumbledSentenceLoading || !jumbledSentenceInput.trim()}
        className={jumbledSentenceLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: jumbledSentenceLoading || !jumbledSentenceInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: jumbledSentenceLoading || !jumbledSentenceInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: jumbledSentenceLoading || !jumbledSentenceInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {jumbledSentenceLoading ? <WaveText /> : jumbledSentenceMode === 'custom' ? 'Create Exercise' : 'Do the magic'}
      </button>

      {generatedJumbledSentence && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Ready: Word Order Exercise
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            {generatedJumbledSentence.sentences.length} sentences ready
          </div>
          <button
            onClick={handleJumbledSentenceInsert}
            className="magic-btn"
            style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
          >
            Add
          </button>
        </div>
      )}
    </div>
  );
}
